import {alpha} from "@mui/material";

export const styles = () => {
    const stageTones = {
        NEW: (theme) => theme.palette.primary.main,
        CONTACTED: (theme) => theme.palette.primary.main,
        NEGOTIATION: (theme) => theme.palette.primary.main,
        PRODUCT_TRIAL: (theme) => theme.brand.plum,
        REGISTRATION_REQUEST: (theme) => theme.brand.slateBlue,
        REGISTERED: (theme) => theme.palette.success.main,
        CLOSED: (theme) => theme.palette.error.main,
        STAND_BY: (theme) => theme.palette.text.secondary,
    };

    const channelTones = {
        Horeca: (theme) => theme.palette.primary.main,
        Retail: (theme) => theme.brand.slateBlue,
        Cadenas: (theme) => theme.brand.plum,
    };

    return {
        container: {
            padding: '1.5rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '1.5rem',
        },
        filterBar: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '1rem',
        },
        filterField: {
            minWidth: 200,
        },
        board: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.5rem',
            overflowX: 'auto',
            paddingBottom: '1rem',
        },
        boardSeparator: {
            alignSelf: 'stretch',
            borderLeft: '1px dashed',
            borderColor: 'divider',
        },
        column: {
            flex: '1 1 0',
            minWidth: 100,
            boxSizing: 'border-box',
            border: '0.5px solid',
            borderColor: 'divider',
            borderRadius: '10px',
            backgroundColor: 'background.paper',
            padding: '0.5rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
        },
        columnAcceptingDrop: {
            borderColor: 'primary.main',
        },
        columnHighlightedForDrop: {
            backgroundColor: 'action.hover',
        },
        columnHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'baseline',
            gap: '0.5rem',
        },
        columnTitle: {
            fontWeight: 600,
            fontSize: '0.875rem',
            lineHeight: 1.2,
        },
        columnCount: {
            color: 'text.secondary',
            fontSize: '0.8rem',
        },
        columnCaption: {
            color: 'text.secondary',
            fontSize: '0.75rem',
            marginTop: '-0.375rem',
        },
        emptyColumn: {
            color: 'text.secondary',
            textAlign: 'center',
            fontSize: '0.8rem',
            padding: '0.75rem 0',
        },
        card: {
            border: '0.5px solid',
            borderColor: 'divider',
            borderRadius: '8px',
            backgroundColor: 'background.default',
            padding: '0.5rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.125rem',
            touchAction: 'none',
            overflowWrap: 'anywhere',
        },
        draggableCard: {
            cursor: 'grab',
        },
        cardLeftBehindWhileDragging: {
            opacity: 0.4,
        },
        cardBeingDragged: {
            cursor: 'grabbing',
            boxShadow: 4,
        },
        cardName: {
            fontWeight: 600,
            fontSize: '0.85rem',
            lineHeight: 1.25,
        },
        cardDetail: {
            color: 'text.secondary',
            fontSize: '0.75rem',
        },
        cardChannelTag: {
            alignSelf: 'flex-start',
        },
        cardToneOfStage: (stage) => (theme) => {
            const tone = stageTones[stage](theme);
            return {backgroundColor: alpha(tone, 0.1), borderLeft: `3px solid ${tone}`};
        },
        cardNameToneOfStage: (stage) => (theme) => ({color: stageTones[stage](theme)}),
        channelTagToneOf: (commercialChannel) => (theme) => {
            const tone = channelTones[commercialChannel](theme);
            return {backgroundColor: alpha(tone, 0.18), color: tone};
        },
    };
};
